import React from 'react';
import FacebookIcon from './../../../../assets/images/svg/icon-facebook.svg'

const FacebookJoin = ({}) => {
  return (
	  <div className="py-20">
		<div className="flex flex-col space-y-5 items-center justify-center">
		  <div className="h-4 text-sky-950 text-lg font-normal font-serif">Join the Conversation</div>
		  <img className="w-10 h-10" src={FacebookIcon} alt="facebook icon" />
		  <div className="text-center text-sky-950 text-sm font-normal">Swap outdoor play ideas and stories with a vibrant community of families.</div>
		  <a className="btn btn-solid block my-3 w-button-md mx-auto text-center" target="_blank" href="/outdoorsall4">Request To Join</a>
		</div>
	  </div>
  )
}

export default FacebookJoin;


// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/facebook_join/FacebookJoin.jsx